import { useTranslation } from "react-i18next";
import Logo from "../../assets/logo.png";
import Button from "../ui/button";

const ServerError = ({ message, onRetry, retrying }) => {
  const { t } = useTranslation("common");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6 text-center">
      <img src={Logo} alt="Solyntek" className="mb-6 h-14 w-auto" />

      <p className="rounded-full bg-orange-50 p-4 text-[#EF8400]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="h-8 w-8"
        >
          <path d="M13 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.25-8.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z" />
          <path d="M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752Zm3.03.751a1.002 1.002 0 0 0-1.732 0L2.168 19.499A1.002 1.002 0 0 0 3.034 21h17.932a1.002 1.002 0 0 0 .866-1.5L12.866 3.994Z" />
        </svg>
      </p>

      <h1 className="mt-6 text-xl font-semibold text-gray-800">{t("server_unreachable")}</h1>
      <p className="mt-2 max-w-sm text-sm text-gray-500">{message || t("server_unreachable_message")}</p>

      <div className="mt-8">
        <Button color="primary" onClick={onRetry} disabled={retrying}>
          {retrying ? t("retrying") : t("retry")}
        </Button>
      </div>
    </div>
  );
};

export default ServerError;
